import { Button, Col, Form, Input, Row, Select, Space } from 'antd';
import { useEffect, useState } from 'react';
import { Enterprise, EnterpriseType1, Tag } from '../../modules/auth';
import { checkGeneralPhoneNumber } from '../../util/utils';
const { Option } = Select;

interface EnterpriseCreateUpdateComponentProps {
  enterprise?: Enterprise;
  gongjongs: Tag[];
  materialVendorTypes: Tag[];
  uploadProps?: any;
  onCreate: (enterprise: Enterprise) => void;
  onCancel: () => void;
}
function EnterpriseCreateUpdateComponent({
  enterprise,
  gongjongs,
  materialVendorTypes,
  uploadProps,
  onCreate,
  onCancel,
}: EnterpriseCreateUpdateComponentProps) {
  const [form] = Form.useForm();
  // const [tagOptions, setTagOptions] = useState<any>();
  const [mount, setMount] = useState(true);
  // useEffect(() => {
  //   if (!mount) return;
  //   const children: any = [];
  //   if (!tags) return;
  //   for (const tag of tags) {
  //     children.push(
  //       <Option key={tag.id} value={tag.name}>
  //         {tag.name}
  //       </Option>,
  //     );
  //   }
  //   setTagOptions(children);
  //   return () => setMount(false);
  // }, [tags, mount]);

  const [gongjongOptions, setGongjongOptions] = useState<any>();
  const [materialVendorTypeOptions, setMaterialVendorTypeOptions] =
    useState<any>();

  useEffect(() => {
    if (!mount) return;
    let children: any = [];
    for (const gongjong of gongjongs) {
      children.push(
        <Option key={gongjong.id} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
    }
    setGongjongOptions(children);
    children = [];
    for (const mvt of materialVendorTypes) {
      children.push(
        <Option key={mvt.id} value={mvt.name}>
          {mvt.name}
        </Option>,
      );
    }
    setMaterialVendorTypeOptions(children);
    return () => setMount(false);
  }, [gongjongs, materialVendorTypes, mount]);

  let title, _enterprise;
  if (!!enterprise) {
    title = '수정';
    _enterprise = {
      ...enterprise,
    };
  } else {
    title = '생성';
    _enterprise = { type1: '1' };
  }

  return (
    <div>
      <Row justify="center" style={{ marginTop: '10px' }}>
        <Col span={12}>
          <h1>회사 {title}</h1>
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: '10px' }}>
        <Col span={12}>
          <Form
            layout="vertical"
            form={form}
            name="control-hooks"
            onFinish={onCreate}
            initialValues={_enterprise}
          >
            <Form.Item
              name="name"
              label="회사명"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="representative"
              label="대표명"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="corporateNumber"
              label="사업자등록번호"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="address"
              label="주소"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="corporatePhone"
              label="전화번호(회사)"
              rules={[
                {
                  required: true,
                },
                {
                  validator: (_, value) => checkGeneralPhoneNumber(value),
                },
              ]}
            >
              <Input type="text" placeholder="회사 전화 번호를 입력하세요." />
            </Form.Item>
            <Form.Item
              name="type1"
              label="회사종류(대분류)"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                allowClear
                style={{ width: '100%' }}
                placeholder="공정을 선택 하세요."
                onClick={() => form.setFieldsValue({ type2: [] })}
              >
                <Option value="1">시공</Option>
                <Option value="2">자재</Option>
              </Select>
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.type1 !== currentValues.type1
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name="type2"
                  label="회사분류(중분류)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="공정을 선택 하세요."
                  >
                    {getFieldValue('type1') === EnterpriseType1.CONTRACTOR
                      ? gongjongOptions
                      : materialVendorTypeOptions}
                  </Select>
                </Form.Item>
              )}
            </Form.Item>
            <Form.Item>
              <Row justify="center">
                <Space size="middle">
                  <Button htmlType="button" onClick={onCancel}>
                    뒤로가기
                  </Button>
                  <Button type="primary" htmlType="submit">
                    확인
                  </Button>
                </Space>
              </Row>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
export default EnterpriseCreateUpdateComponent;
